export const LogoMark = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#FAF6E9" stroke="#E5DECF" />
    <circle cx="32" cy="16.5" r="5.5" fill="#EA580C" />
    <g stroke="#F5A623" strokeWidth="2" strokeLinecap="round">
      <line x1="32" y1="6" x2="32" y2="8.5" />
      <line x1="22.5" y1="10" x2="24.2" y2="11.7" />
      <line x1="41.5" y1="10" x2="39.8" y2="11.7" />
    </g>
    <path
      d="M11 33c7.5-4.2 14.5-4.2 21 .4 6.5-4.6 13.5-4.6 21-.4v16.5c-7.5-4.2-14.5-4.2-21 .4-6.5-4.6-13.5-4.6-21-.4z"
      fill="#1E1B4B"
    />
    <path d="M32 33.4v16.5" stroke="#FAF6E9" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export default function Logo({ name, role }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark size={42} />
      <span className="leading-tight">
        <span className="block font-display text-lg text-ink">{name}</span>
        <span className="hidden text-[11px] font-semibold uppercase tracking-[0.14em] text-[#D97706] whitespace-nowrap sm:block">
          {role}
        </span>
      </span>
    </span>
  );
}
